/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import { START_TOUR, STOP_TOUR } from 'state/Tour/TourActions';

export const tourReducer = (state, action) => {
  if (action.type === START_TOUR) {
    return true;
  }
  if (action.type === STOP_TOUR) {
    return false;
  }
  return state;
};
